function Paragraphs({ paragraphs }) {
    if (!paragraphs || paragraphs.length === 0) return null;
    return (
        <div className="text-1xl">
            {paragraphs.map((text, i) => (
                <div key={i}>
                    {i > 0 && <br />}
                    <p>{text}</p>
                </div>
            ))}
        </div>
    );
}

export default Paragraphs;
